import React, { Component } from 'react';
import { connect } from 'react-redux';

import { userSetFieldFetch } from './../../store/user/actions';

import Checkbox from './../Checkbox';
import TimeDropdown from './TimeDropdown';
import SubjectsTypeDropdown from './SubjectsTypeDropdown';

class NotificationsForm extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(event) {
        const { target } = event;
        const { notifications, save } = this.props;
        notifications[target.name] = target.checked;
        save(notifications);
    }

    render() {
        const { notifications, isLoading } = this.props;
        return (
            <div className="notifications-box">
                <h4 className="title-devider"><span>Email</span></h4>
                <div className="row mb20">
                    <div className="col-1">
                        <Checkbox checked={notifications.orders_top} name="orders_top" onChange={this.onChange} className="default" disabled={isLoading}>
                            Morning digest of Available orders
                        </Checkbox>
                        <div className="dropdown-box">
                            <TimeDropdown name="orders_top_time" />
                            <SubjectsTypeDropdown name="orders_top_subjects" />
                        </div>
                        <Checkbox checked={notifications.orders_top_evening} name="orders_top_evening" onChange={this.onChange} className="default" disabled={isLoading}>
                            Evening digest of Available orders
                        </Checkbox>
                        <div className="dropdown-box">
                            <TimeDropdown name="orders_top_time_evening" />
                            <SubjectsTypeDropdown name="orders_top_evening_subjects" />
                        </div>
                    </div>
                    <div className="col-1">
                        <Checkbox checked disabled>A new message in the system</Checkbox>
                        <Checkbox checked disabled>Restore password</Checkbox>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    notifications: state.user.notifications,
    isLoading: state.user.fetchingFields.indexOf('notifications') > -1
});

const mapDispatchToProps = dispatch => ({
    save: value => dispatch(userSetFieldFetch('notifications', value))
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsForm);


// WEBPACK FOOTER //
// ./src/components/profile/NotificationsForm.js